<div class="flex-center wd-100-hg-100">
  <div class="spinner"></div>
</div>
